import React, { useState } from 'react';
import moment from 'moment';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  MenuItem,
  DialogActions,
  Button,
  TextField,
  ListItemText,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import TimeSelect from '../../../components/TimeSelect';
import DateSelect from '../../../components/DateSelect';
import UpdateModal from './UpdateModal';
import CancellationModal from './CancellationModal';
import ProviderSearchBar from '../../../components/ProviderSearchBar';
import { fetchProvider } from '../../../services/api';

function AppointmentModal(props) {
  const {
    open,
    onClose,
    currentProvider,
    refeshAppointments,
    apptCountUpdate,
    currentUserId,
    selectedAppt,
    currentUser,
    classes: { dialogFooter, action },
  } = props;

  const [toProvider, setToProvider] = useState(currentProvider);
  const [newApptInfo, setNewApptInfo] = useState({ ...selectedAppt });
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openCancellationModal, setOpenCancellationModal] = useState(false);
  
  const changeProvider = async provider => {
    if (provider) {
      const nextProvider = await fetchProvider(provider.id);
      setNewApptInfo({
        ...newApptInfo,
        tenancyId: nextProvider.tenancies[0].id,
      });
      setToProvider(nextProvider);
    }
  };
  
  const handleFieldChange = e => {
    
    if(e.target.name === 'durationMinutes' && (e.target.value > 1440 || !/^\d*$/.test(e.target.value))) return;
    const updatedApptInfo = {
      ...newApptInfo,
      [e.target.name]: e.target.value,
    };
    // we need this information to show the diff on the confirmation modal
    if (e.target.name === 'tenancyId') {
      updatedApptInfo.tenancyLocation = toProvider.tenancies.find(
        tenancy => tenancy.id === e.target.value
      ).location;
    }
    setNewApptInfo(updatedApptInfo);
  };

  const handleTimeChange = e => {
    const newTime = moment(
      moment(newApptInfo.time).format('MM/DD/YYYY') +
        ' ' +
        moment(e.target.value).format('HH:mm')
    ).toISOString();

    setNewApptInfo({
      ...newApptInfo,
      time: newTime,
    });
  };

  const handleDateChange = date => {
    const newTime = moment(
      moment(date).format('MM/DD/YYYY') +
        ' ' +
        moment(newApptInfo.time).format('HH:mm')
    ).toISOString();
    if (newTime) {
      setNewApptInfo({
        ...newApptInfo,
        time: newTime,
      });
    }
  };

  return (
    <>
      <Dialog
        fullWidth
        open={open}
        onClose={onClose}
        maxWidth="sm"
        margin="normal"
      >
        <DialogTitle>Appointment</DialogTitle>
        <DialogContent>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <ProviderSearchBar
              clearable={false}
              label="Provider"
              variant="outlined"
              name="toProvider"
              placeholder={toProvider.fullTitle}
              onSelect={changeProvider}
            />
          </FormControl>

          <FormControl variant="outlined" margin="normal" fullWidth>
            <TextField
              select
              label="Tenancy"
              name="tenancyId"
              onChange={handleFieldChange}
              value={newApptInfo.tenancyId}
              variant="outlined"
            >
              {toProvider.tenancies.map(tenancy => (
                <MenuItem key={`menu-${tenancy.id}`} value={tenancy.id}>
                  <ListItemText primary={tenancy.location} />
                </MenuItem>
              ))}
            </TextField>
          </FormControl>

          <FormControl variant="outlined" margin="normal" fullWidth>
            <TextField
              label="Patient Name"
              value={selectedAppt.patientName}
              variant="outlined"
              inputProps={{
                readOnly: true,
                disabled: true,
              }}
            />
          </FormControl>

          <FormControl variant="outlined" margin="normal" fullWidth>
            <TextField
              label="Patient DOB"
              value={selectedAppt.patientDOB}
              variant="outlined"
              inputProps={{
                readOnly: true,
                disabled: true,
              }}
            />
          </FormControl>

          <FormControl variant="outlined" margin="normal" fullWidth>
            <TextField
              label="Patient Tebra ID"
              value={selectedAppt.patientTebraId}
              variant="outlined"
              inputProps={{
                readOnly: true,
                disabled: true,
              }}
            />
          </FormControl>

          <FormControl variant="outlined" margin="normal" fullWidth>
            <TextField
              label="Patient Phone"
              value={selectedAppt.patientPhone}
              variant="outlined"
              inputProps={{
                readOnly: true,
                disabled: true,
              }}
            />
          </FormControl>

          <FormControl variant="outlined" margin="normal" fullWidth>
            <TextField
              label="Patient Email"
              value={selectedAppt.patientEmail}
              variant="outlined"
              inputProps={{
                readOnly: true,
                disabled: true,
              }}
            />
          </FormControl>

          <FormControl variant="outlined" margin="normal" fullWidth>
            <DateSelect
              fullWidth
              variant="outlined"
              label="Starts on"
              name="date"
              format="MM/DD/YYYY"
              placeholder="MM/DD/YYYY ex. 01/01/2001"
              value={new Date(newApptInfo.time)}
              onChange={handleDateChange}
            />
          </FormControl>

          <FormControl variant="outlined" margin="normal" fullWidth>
            <TimeSelect
              name="time"
              label="From"
              time={newApptInfo.time}
              onChange={handleTimeChange}
            />
          </FormControl>

          <TextField
            fullWidth
            variant="outlined"
            label="Appointment Length (in minutes)"
            type="number"
            name="durationMinutes"
            value={newApptInfo.durationMinutes}
            onChange={handleFieldChange}
          />
        </DialogContent>

        <DialogActions className={dialogFooter}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            className={action}
            type="submit"
          >
            Back
          </Button>
          {currentUser.admin && <Button
            type="submit"
            onClick={() => setOpenUpdateModal(!openUpdateModal)}
            color="primary"
            variant="outlined"
          >
            Update Appointment
          </Button>}
          

          <Button
            type="submit"
            onClick={() => setOpenCancellationModal(!openCancellationModal)}
            variant="outlined"
            color="secondary"
            className={action}
          >
            Cancel Appointment
          </Button>
        </DialogActions>

        <UpdateModal
          open={openUpdateModal}
          selectedApptInfo={selectedAppt}
          newApptInfo={newApptInfo}
          provider={toProvider}
          refeshAppointments={refeshAppointments}
          onClose={() => {
            onClose();
            setOpenUpdateModal(!openUpdateModal);
          }}
        />

        <CancellationModal
          open={openCancellationModal}
          selectedApptInfo={selectedAppt}
          onClose={() => {
            onClose();
            setOpenCancellationModal(!openCancellationModal);
          }}
          refeshAppointments={()=> refeshAppointments(selectedAppt.providerId)}
          apptCountUpdate={apptCountUpdate}
          currentUserId={currentUserId}
        />
      </Dialog>
    </>
  );
}

const styles = () => ({
  dialogFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#ADADAD',
  },
  button: {
    backgroundColor: '#424B5A',
    color: 'white',
  },
  action: {
    marginLeft: '5px',
  },
  danger: {
    color: '#F44336',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
});

export default withStyles(styles)(AppointmentModal);
